import { render, staticRenderFns } from "./SequenceList.vue?vue&type=template&id=48a05c60&scoped=true"
import script from "./SequenceList.vue?vue&type=script&lang=js"
export * from "./SequenceList.vue?vue&type=script&lang=js"
import style0 from "./SequenceList.vue?vue&type=style&index=0&id=48a05c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a05c60",
  null
  
)

export default component.exports